<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <h1 class="hdg02">新規ご契約申込</h1>
            <a href="/lc/about/" target="_blank" class="contact-head-link">LEGAL CONNECTIONについて <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
          </div>
          <div class="contact-container">
            <div class="contact-navigation">
            </div>
            <div class="contact-content">
              <h2 class="hdg03">新規契約をご希望される方</h2>
              <div class="contact-content-info">
                <div class="column">
                  <div class="column-item col-12 space-gutter">
                    <p class="txt">新規ご契約のお申し込みの際は「新日本法規WEB会員」ログインが必要です。</p>
                    <p class="txt">詳しくは「<a href="/guide/autolc/" class="txt-blue" target="_blank">LEGAL CONNECTION自動決済サービス</a>」をご参照ください。</p>
                    <p class="txt mb32">下記手順をご確認いただきお進みください。なお、申し込み完了後は、即時ご利用開始いただけます。</p>
                    <div class="inner">
                      <h3 class="hdg03 ta-center">新日本法規WEB会員の方はこちら</h3>
                      <hr class="mt32 mb32">
                      <p class="txt">「ログインする」ボタンを押下し、新日本法規WEBサイトへログインすると「新規契約申込フォーム」へ進みますのでお申し込みください。</p>
                      <div class="login-btn-wrp">
                        <div class="button login-btn"><a href="/shop/signin?redirect_form=new_application_before_login" class="btn" @click="group1.onClickLoginButton">ログインする</a></div>
                      </div>
                    </div>
                    <div class="inner mt40">
                      <h3 class="hdg03 ta-center">新日本法規WEB会員登録がお済みでない方はこちら</h3>
                      <h3 class="ta-center txt-notice">《新規会員登録にあたっての注意事項とお願い》</h3>
                      <h3 class="txt-notice">下記①の「新規会員登録」ボタンより会員登録が完了されましたら、ブラウザ上部のタブ「新規ご契約申込」を押下し当ページに戻り、②の「新規契約申込」を押下してお進みください。</h3>
                      <hr class="mt32 mb32">
                      <p class="txt">①「新規会員登録」ボタンを押下し、新日本法規WEB会員新規登録を行ってください。</p>
                      <div class="login-btn-wrp">
                        <div class="button login-btn"><a href="/shop/signup" class="btn" target="_blank" @click="group1.onClickLoginButton">新規会員登録<FontawesomeIcon icon="external-link-alt" class="icn" /></a></div>
                      </div>
                      <hr class="mt40 mb40">
                      <p class="txt mb40">②新日本法規WEB会員登録後、「新規契約申込」を押下してお申し込みください。</p>
                      <div class="application-btn-wrp">
                        <div class="ta-center link">
                          <button @click="group1.onClickNewApplicationButton">新規契約申込</button>
                          <p class="txt-error" v-if="group1.isWebSessionFetched && !group1.isWebSessionValid">新日本法規WEB会員にログインしておりません。</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h2 class="hdg03">お見積りをご希望される方</h2>
              <div class="contact-content-info">
                <div class="column">
                  <div class="column-item col-12 space-gutter">
                    <p class="txt mb20">
                      LEGAL CONNECTIONのお見積り依頼ができます。「お見積りフォーム」を押下して必要事項をご記入いただきお申し込みください。<br>
                      弊社担当者よりご登録のメールアドレス宛にお見積りを送信いたします。
                    </p>
                    <div class="mb20">
                      <router-link class="link" to="/public/estimate/index">お見積りフォーム</router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onBeforeMount, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'
import * as logicSelectApplication from '@/logic/public/SelectApplication'

export default defineComponent({
  components: {
  },
  setup (props, context) {

    onMounted(() => {

    })
    const group1 = logicSelectApplication.getGroupIndex()
    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.contact {
  @media screen and (max-width:$width-container) {
    &-head {
      .hdg02 {
        padding-top: 20px;
      }
    }
  }

  &-content-info .inner {
    padding: 40px;
    background: $color-bg-paper;
    hr {
      border-top: 1px solid $color-line;
    }
    .txt-error {
      color: $color-errorbox;
      margin-top: 5px;
    }
    .txt-notice {
      color: $color-notice;
      margin-top: 5px;
    }
  }
  .login-btn-wrp,
  .application-btn-wrp {
    text-align: center;
  }
  .login-btn,
  .application-btn {
    width: 200px;
    margin-top: 40px;
  }
  .login-btn {
    margin-right: auto;
    margin-left: auto;
    .icn {
      font-size: 12px;
      margin-left: 8px;
      padding-bottom: 1px;
    }
  }
  .login-btn .btn,
  .application-btn .btn {
    border: 0;
    background-color: $color-link;
    color: #FFF;
  }

  .column {
    width: 100%;
    .link {
      color: $color-link;
    }
  }
}
</style>
